<script>
export default {
  name: "NavBar",
  props: {
    menu: Array,
  },
  data() {
    return {
      // menu: [
      //   {
      //     id: 1,
      //     name: "Стенды",
      //     href: "/companies/list",
      //     icon: "diagram3",
      //     isActive: false,
      //   },
      //   {
      //     id: 2,
      //     name: "Конференц-зал",
      //     href: "/conference/room",
      //     icon: "chat-right-quote",
      //     isActive: false,
      //   },
      //   {
      //     id: 3,
      //     name: "Пользователи",
      //     href: "/user/manage",
      //     icon: "people",
      //     isActive: false,
      //   },
      //   {
      //     id: 4,
      //     name: "Статистика",
      //     href: "/analytic",
      //     icon: "bar-chart-line",
      //     isActive: false,
      //   },
      // ],
    }
  },
  computed: {
    getMenu() {
      return this.menu.map((item) => {
        if (item.href.split("/")[1] === location.pathname.split("/")[1]) item.isActive = true
        return item
      })
    },
  },
}
</script>

<style>
ul.active a {
  color: blue;
}
</style>
